export default ({ currentUser }) => ({
  duration: { hour: 1, minute: 0 },
  rrule: { frequency: null },
  speakers: [],
  start_zone: currentUser.data.tzid,
});
